import { ProgramCategory } from '@gql/generated';
import Styled from 'styled-components';
import Icon from './Icon';

export declare type VideoStatus = 'done' | 'progress' | '';
export const VideoBoxNumber = Styled.span<{
  videoStatus: VideoStatus;
  appearance?: ProgramCategory;
}>`
  position: absolute;
  top: 0;
  left: -20px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.neutrals.black};
  font-weight: 600;
  line-height: 1.1;
  border: 2px solid ${({ theme }) => theme.colors.neutrals['gray-3']};
  border-radius: 50%;
  padding: 1px;
  background-color: white;
  transform: translateX(-50%);
  z-index: 2;

  ${({ theme, videoStatus, appearance }) => {
    const color =
      appearance === ProgramCategory['Challenges']
        ? theme.colors.primary['green']
        : theme.colors.primary['blue-2'];

    if (videoStatus === 'done') {
      return `
          color: white;
          border-color: ${color};
          background-color: ${color};
        `;
    } else if (videoStatus === 'progress') {
      return `
          color: ${color}; 
          border-color: ${color};
        `;
    } else {
      return `border-color: ${theme.colors.neutrals['gray-3']};`;
    }
  }}
`;

type Props = {
  videoStatus: VideoStatus;
  videoLabel: string;
  appearance?: ProgramCategory;
};

const VideoNumber = ({ videoStatus, videoLabel, appearance }: Props) => {
  return (
    <VideoBoxNumber videoStatus={videoStatus} appearance={appearance}>
      {videoStatus === 'done' ? (
        <Icon name="ygb-icon-checkmark" fontSize="10px" />
      ) : (
        videoLabel
      )}
    </VideoBoxNumber>
  );
};

export default VideoNumber;
